import React, { useState } from "react";
import CategoryForm from "./CategoryForm";
import { createCategory } from "../../api/categoryService";
import { getErrorMessage } from "../../utils/errorHandler";

const SEO_REFERENCE_TYPE = Object.freeze({
  CATEGORY: "Category",
});

export default function AddCategory() {
  const [loading, setLoading] = useState(false);
  const [backendErrors, setBackendErrors] = useState({});

  const handleAddCategory = async (payload) => {
    try {
      setLoading(true);
      setBackendErrors({});

      const categoryPayload = {
        name: payload.name,
        tagline: payload.tagline,
        description: payload.description,
        status: payload.status,
        hsnCode: payload.hsnCode,
        taxApplied: payload.taxApplied,
        taxId: payload.taxId,
        type: payload.type,
        parentId: payload.parentId,
        referenceType: SEO_REFERENCE_TYPE.CATEGORY,
        metaTitle: payload.metaTitle || payload.name || "",
        metaKeywords: Array.isArray(payload.metaKeywords)
          ? payload.metaKeywords
          : (payload.metaKeywords || "")
              .split(",")
              .map((item) => item.trim())
              .filter(Boolean),
        metaDescription: payload.metaDescription || "",
        metaImage: payload.metaImage || "",
      };

      const categoryResponse = await createCategory(categoryPayload);
      if (categoryResponse?.success === false || categoryResponse?.status === 422) {
        setBackendErrors(categoryResponse?.error || {});
        return false;
      }

      return true;
    } catch (error) {
      console.error("Create Category Error:", error);

      // Axios error response
      const errorData = error?.response?.data;

      if (errorData?.status === 422 || errorData?.success === false) {
        setBackendErrors(errorData?.error || {});
        return false;
      }

      alert(getErrorMessage(error));
      return false;
    } finally {
      setLoading(false);
    }
  };

  return (
    <CategoryForm
      onSubmit={handleAddCategory}
      loading={loading}
      backendErrors={backendErrors}
      isEdit={false}
    />
  );
}
